<template>
  <div class="rev-print">
    <slot name="header" />
    <slot name="info" />
  </div>
</template>

<script>
export default {
  name: 'RevPrintWrapper',
}
</script>

<style lang="scss" scoped>
@page {
  size: auto;
  margin: none !important;
}

@media print {
  .rev-print {
    background: $color-white;
    margin: 0px !important;
    padding: 0px !important;
    page-break-inside: avoid;
    page-break-after: auto;
    display: inline-block;
    width: 100% !important;
  }
  html,
  body {
    margin: 0 !important;
  }
}

p,
h2,
h3 {
  orphans: 3;
  widows: 3;
}

.rev-print {
  background: $color-white;
  color: $color-black;
  font-family: Verdana, Geneva, sans-serif;
  font-size: 10px;
  page-break-after: always;
  color-adjust: exact;
  box-shadow: 0 0.5mm 2mm rgba(0, 0, 0, 0.3);
  padding: 30px;
  margin: 15px;
  display: inline-block;
}
</style>
